import { render, staticRenderFns } from "./mediationList.vue?vue&type=template&id=53dde25e"
import script from "./mediationList.vue?vue&type=script&lang=js"
export * from "./mediationList.vue?vue&type=script&lang=js"
import style0 from "./mediationList.vue?vue&type=style&index=0&id=53dde25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports